import React, { FC } from 'react'
import { Box, Typography, IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { REQUEST_ID_STYLES } from '@/apps/legacy/shared/constants/styles'
import { FONT_MONO } from '@/shared/styles/typography'

interface RequestIdDisplayProps {
  requestId: string
  onCopy: () => void
}

export const RequestIdDisplay: FC<RequestIdDisplayProps> = ({
  requestId,
  onCopy,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        mb: 1,
        px: 2,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: REQUEST_ID_STYLES.colors.text,
          fontSize: REQUEST_ID_STYLES.fontSize,
        }}
      >
        リクエストID:
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: REQUEST_ID_STYLES.colors.text,
          fontSize: REQUEST_ID_STYLES.fontSize,
          fontFamily: FONT_MONO.fontFamily,
        }}
      >
        {requestId}
      </Typography>
      <Tooltip title="リクエストIDをコピー" placement="top">
        <IconButton
          size="small"
          aria-label="リクエストIDをコピー"
          onClick={onCopy}
          sx={{
            p: 0.5,
            color: REQUEST_ID_STYLES.colors.icon,
            '&:hover': {
              color: REQUEST_ID_STYLES.colors.iconHover,
            },
          }}
        >
          <ContentCopyIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
